import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

export const USERS_BASE_PATH = EvidencePlatformSidebarAppID.users;

export const getUsersBasePath = () => `/${USERS_BASE_PATH}`;
